module.exports = __webpack_public_path__ + "static/media/amazing_restaurant_2.b873b60c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/images/amazing_restaurant_2.jpg
// module id = 302
// module chunks = 0